import React from 'react';
import { Link } from 'react-router-dom';

const StatusEmptyCard = ({ copy, detail, onAction }) => {
    const to = copy.href;

    return (
        <div className="status-empty-card w-10/12 mb-6" data-testid="status-empty-card">
            <p className="status-empty-eyebrow">{copy.eyebrow}</p>
            <h2>{copy.headline}</h2>
            <p>{copy.body}</p>
            {detail ? <p className="status-empty-detail">{detail}</p> : null}
            {onAction ? (
                <button className="status-empty-cta" type="button" onClick={onAction}>
                    {copy.cta}
                    {copy.cta === 'Retry' ? <span> ↻</span> : null}
                </button>
            ) : to ? (
                <Link className="status-empty-cta" to={to}>
                    {copy.cta} <span>↗</span>
                </Link>
            ) : null}
            <p className="status-empty-note">{copy.note}</p>
        </div>
    );
};

export default StatusEmptyCard;
